import type { FunctionComponent } from 'react';
import { useContext } from 'react';

import { Card, Center, Grid, Stack, Text, Title } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';

import { HeadquarterContext } from 'context/HeadquarterContext';
import { RenderHours } from 'components/ThirdPartyMenus';

import { breakpoints } from 'styles/theme.variables';

export const Schedule: FunctionComponent = () => {
  const { location } = useContext(HeadquarterContext);
  const { pickup, delivery } = location?.fulfillment || {};
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);
  const colSpan = isMobile ? 12 : 6;

  const hasPickupSchedule = !!(pickup && pickup?.display_hours?.length > 0);
  const hasDeliverySchedule = !!(delivery && delivery?.display_hours?.length > 0);

  if (!hasPickupSchedule && !hasDeliverySchedule) {
    return (
      <Card>
        <Center>
          <Text mt="xl" mb="xl">
            No Schedules Available
          </Text>
        </Center>
      </Card>
    );
  }

  return (
    <Stack gap={0} mt="xl">
      <Title order={6} mb="md">
        Schedule
      </Title>
      <Grid justify="flex-start" gutter="md">
        {hasPickupSchedule && (
          <Grid.Col span={colSpan}>
            <RenderHours
              title="Store Hours"
              displayHours={pickup.display_hours}
              fulfillmentType="pickup"
            />
          </Grid.Col>
        )}
        {hasDeliverySchedule && (
          <Grid.Col span={colSpan}>
            <RenderHours
              title="Delivery Hours"
              displayHours={delivery.display_hours}
              fulfillmentType="delivery"
            />
          </Grid.Col>
        )}
      </Grid>
    </Stack>
  );
};
